import { render, staticRenderFns } from "./ChatMessageSwitch.vue?vue&type=template&id=f39e017c&scoped=true"
import script from "./ChatMessageSwitch.vue?vue&type=script&lang=ts"
export * from "./ChatMessageSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessageSwitch.vue?vue&type=style&index=0&id=f39e017c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39e017c",
  null
  
)

export default component.exports